// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3wS0b","amount":"Amount_amount__P620Y","tip":"Amount_tip__2mcML","tipHeader":"Amount_tipHeader__3_QJA","tipsWrap":"Amount_tipsWrap__2h2L_"};